import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ComplaintsState = {
  modalOpened: boolean;
  offerId: number | null;
};

const initialState: ComplaintsState = {
  modalOpened: false,
  offerId: null,
};

export const { reducer: complaintsReducer, actions: complaintsActions } = createSlice({
  name: 'complaints',
  initialState,
  reducers: {
    complaitToOffer: (state, action: PayloadAction<number>) => {
      state.offerId = action.payload;
      state.modalOpened = true;
    },
    closeModal: state => {
      state.modalOpened = false;
      state.offerId = null;
    },
  },
});
